import { FC } from 'react'

export interface CloseButtonProps {
  onClose: () => void
}

const CloseButton: FC<CloseButtonProps> = ({ onClose }) => {
  return (
    <button
      onClick={onClose}
      className="w-[36px] h-[36px] bg-black/50 backdrop-blur-sm text-white rounded-full hover:bg-black/70 transition-colors flex items-center justify-center"
      aria-label="Close"
    >
      <svg className="w-[24px] h-[24px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  )
}

export default CloseButton
